class ScrollSmooth {
    constructor(el) {
        this._createElements(el);
        this._addEvents();
    }
    _createElements(el){
        this.btn = el;
        this.uid = this.btn.hash.replace('#', '');
        this.data = JSON.parse(this.btn.getAttribute('data-param')) || {};
        this.inArea = this.data.inArea || false;
        this.blockArea = document.getElementById(this.uid) || null;
        let header = document.querySelector('.navigation') || document.querySelector('.header');
        this.offset = - header.clientHeight;
    }
    _addEvents(){
        let self = this;

        window.addEventListener('load', () => {
            self._checkHash();
        });

        this.btn.onclick = function(e){
            if ( !self._checkArea() ) {
                self._smoothScroll(self.uid);
                window.location.hash = this.hash;
            }

            e.preventDefault();
        };
    }

    _checkArea(){
        let self = this;

        if ( self.blockArea && !self.inArea ) {

            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            let blockRect = self.blockArea.getBoundingClientRect();
            let blockOffset = blockRect.top + scrollTop;
            let blockHeight = self.blockArea.clientHeight;

            let btnRect = self.btn.getBoundingClientRect();
            let btnOffset = btnRect.top + scrollTop;
            let btnHeight = self.btn.clientHeight;

            if ( ( btnOffset > blockOffset ) && ( (btnOffset + btnHeight) < (blockOffset + blockHeight) ) ) {
                return true;
            } else {
                return false;
            }

        }
    }

    _currentYPosition() {
        // Firefox, Chrome, Opera, Safari
        if (self.pageYOffset) return self.pageYOffset;
        // Internet Explorer 6 - standards mode
        if (document.documentElement && document.documentElement.scrollTop)
            return document.documentElement.scrollTop;
        // Internet Explorer 6, 7 and 8
        if (document.body.scrollTop) return document.body.scrollTop;
        return 0;
    }
    _elmYPosition(eID) {
        let elm = document.getElementById(eID);
        let y = elm.offsetTop;
        let node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
            node = node.offsetParent;
            y += node.offsetTop;
        } return y+this.offset;
    }

    _smoothScroll(eID) {
        let startY = this._currentYPosition();
        let stopY = this._elmYPosition(eID);
        let distance = stopY > startY ? stopY - startY : startY - stopY;
        if (distance < 100) {
            scrollTo(0, stopY); return;
        }
        let speed = Math.round(distance / 100);
        if (speed >= 200) speed = 1000;
        let step = Math.round(distance / 25);
        let leapY = stopY > startY ? startY + step : startY - step;
        let timer = 0;
        if (stopY > startY) {
            for ( let i=startY; i<stopY; i+=step ) {
                setTimeout("window.scrollTo(0, "+leapY+")", timer*speed);
                leapY += step; if (leapY > stopY) leapY = stopY; timer++;
            } return;
        }
        for ( let i=startY; i>stopY; i-=step ) {
            setTimeout("window.scrollTo(0, "+leapY+")",  timer*speed);
            leapY -= step; if (leapY < stopY) leapY = stopY; timer++;
        }
    }

    _checkHash(){
        let self = this;
        //
        if(window.location.hash === self.btn.hash){
            self._smoothScroll(self.uid);
        }
    }
    _del(){}

}

export {ScrollSmooth};



